import React from 'react';
import { graphql, compose } from "react-apollo";

import $ from 'jquery';

import * as GraphqlTag from "../GraphQL/MutationSetting";
import BreadCrumb from './BreadCrumb';
import Spinner from './Spinner';
import * as MESSAGES from '../Lib/Messages';
import Notification from './Notification';
import * as Utils from '../Lib/Utils';
import { convertEmptyString } from '../Lib/Utils';
import moment from "moment";

class Setting extends React.Component {
	subCognito = localStorage.getItem('subHandsApps');

	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			isEdit: false,
			errors: {},
			isError: false,
			errorMessage: '',
		};

		this.state = {...this.getInitialState(), ...this.state};
		this.handleChange = this.handleChange.bind(this);
		this.handleOnBlur = this.handleOnBlur.bind(this);
	}

	getInitialState = () => ({
		setting: {
			...{
				id: this.subCognito,
				handSide: "LT",
				assessmentType: "SWMT",
				created: moment.utc().format(),
				updated: moment.utc().format()
			}
		}
	});

	handleChange(event) {
		const { target: { name, value } } = event;
		const { setting, errors } = this.state;

		setting[name] = value;
		this.setState({ setting });

		if(errors[name]) {
			delete errors[name];
		}
	}

	handleOnBlur(event) {
		const { target: { name, value } } = event;
		const { setting, errors } = this.state;

		setting[name] = value;
		this.setState({ setting });

		if(errors[name]) {
			delete errors[name];
		}
		this.loadColorBox();
	}

	isValidation() {
		this.setState({errors: {}, errorMessage: ''});

		var errors = {};
		var isError = false;

		if(!window.navigator.onLine) {
			this.setState({ errorMessage: MESSAGES.ERROR_NETWORK_CONNECTION, isError: true });
			isError = true;
		}

		if(isError) {
			this.setState({ errors });
			return false;
		}

		return true;
	}

	clearForm = () => {
		this.setState(this.getInitialState());
	}

	handleSave = async (e) => {
		e.stopPropagation();
		e.preventDefault();

		if(!this.isValidation()) {
			return false;
		}

		this.setState({ loading: true });

		const { createSetting, updateSetting } = this.props;
		const { setting } = this.state;
		setting['updated'] = moment.utc().format();
		let results = { data: {} };

		try {
			if(this.state.isEdit) {
				results = await updateSetting(setting);
			} else {
				setting['created'] = moment.utc().format();
				results = await createSetting(setting);
			}

			if(results.data) {
				this.setState({ errorMessage: MESSAGES.SUCCESS_UPDATE_SETTING, isError: false });
			} else {
				this.setState({ errorMessage: MESSAGES.ERROR_UPDATE_SETTING, isError: true });
			}
		} catch(e) {
			this.setState({ errorMessage: MESSAGES.ERROR_UPDATE_SETTING, isError: true });
		}

		this.setState({ loading: false });
	}

	loadColorBox() {
		$('.input-group.color').each(function(index, element) {
			let color = $(element).find('input').val();
			$(element).find('i').css('background-color', color);
		});
	}

	componentDidMount() {
		// window.initColorPicker();
		// this.loadColorBox();
		if(!window.navigator.onLine) {
			this.setState({ errorMessage: MESSAGES.ERROR_NETWORK_CONNECTION, isError: true });
		}
	}

	componentWillReceiveProps(newProps) {
		const { settingData } = newProps;
		if(settingData) {
			this.setState({ isEdit: true });
			const { setting } = this.state;
			setting['handSide'] = settingData.handSide;
			setting['assessmentType'] = settingData.assessmentType;
			setting['created'] = settingData.created;
			this.setState({ setting });
		}
	}

	render() {
		const { loading, setting } = this.state;
		return (
			<section role="main" className="content-body">
				<header className="page-header">
					<h2>Setting</h2>
					<BreadCrumb title1="Dashboard" title2="Setting" />
				</header>

				<Notification isError={this.state.isError} message={this.state.errorMessage} />

				<div className="row">
						<div className="col">
							<section className="card">
								<div className={`card-body${loading || this.props.loading ? ' loading-overlay-showing' : ''}`}>
			                        <Spinner />
									<form className="form-horizontal form-bordered" method="POST">
										<div className="form-group row">
											<label className="col-lg-3 control-label text-lg-right pt-2">Hand Side Default</label>
											<div className="col-lg-6">
												<div className="input-group">
													<span className="input-group-addon">
														<i className="fa fa-hand-paper"></i>
													</span>
							                        <select id="handSide" name="handSide" className="form-control" value={setting.handSide} onChange={this.handleChange}>
							                        	{Utils.HAND_SIDE.map((item, i) => <option key={i} value={item.key}>{item.value}</option>)}
							                        </select>
												</div>
											</div>
										</div>

										<div className="form-group row">
											<label className="col-lg-3 control-label text-lg-right pt-2">Assessment Type Default</label>
											<div className="col-lg-6">
												<div className="input-group">
													<span className="input-group-addon">
														<i className="fa fa-palette"></i>
													</span>
							                        <select id="assessmentType" name="assessmentType" className="form-control" value={setting.assessmentType} onChange={this.handleChange}>
							                        	<option value="SWMT">SWMT</option>
							                        	<option value="WEST">WEST</option>
							                        </select>
												</div>
											</div>
										</div>

										{ /*
										<div className="form-group row">
											<label className="col-lg-3 control-label text-lg-right pt-2">Color 0.07</label>
											<div className="col-lg-6">
												<div className="input-group color colorGreen" data-plugin-colorpicker>
													<span className="input-group-text input-group-addon"><i></i></span>
													<input type="text" name="colorGreen" className="form-control"
														value={setting.colorGreen}
														onChange={this.handleChange}
														onBlur={this.handleOnBlur}
													/>
												</div>
											</div>
										</div>

										<div className="form-group row">
											<label className="col-lg-3 control-label text-lg-right pt-2">Color 0.2</label>
											<div className="col-lg-6">
												<div className="input-group color colorBlue" data-plugin-colorpicker>
													<span className="input-group-text input-group-addon"><i></i></span>
													<input type="text" name="colorBlue" className="form-control"
														value={setting.colorBlue}
														onChange={this.handleChange}
														onBlur={this.handleOnBlur}
													/>
												</div>
											</div>
										</div>

										<div className="form-group row">
											<label className="col-lg-3 control-label text-lg-right pt-2">Color 2.0</label>
											<div className="col-lg-6">
												<div className="input-group color colorPurple" data-plugin-colorpicker>
													<span className="input-group-text input-group-addon"><i></i></span>
													<input type="text" name="colorPurple" className="form-control"
														value={setting.colorPurple}
														onChange={this.handleChange}
														onBlur={this.handleOnBlur}
													 />
												</div>
											</div>
										</div>

										<div className="form-group row">
											<label className="col-lg-3 control-label text-lg-right pt-2">Color 4.0</label>
											<div className="col-lg-6">
												<div className="input-group color colorRed" data-plugin-colorpicker>
													<span className="input-group-text input-group-addon"><i></i></span>
													<input type="text" name="colorRed" className="form-control"
														value={setting.colorRed}
														onChange={this.handleChange}
														onBlur={this.handleOnBlur}
													/>
												</div>
											</div>
										</div>

										<div className="form-group row">
											<label className="col-lg-3 control-label text-lg-right pt-2">Color 200</label>
											<div className="col-lg-6">
												<div className="input-group color colorOrange" data-plugin-colorpicker>
													<span className="input-group-text input-group-addon"><i></i></span>
													<input type="text" name="colorOrange" className="form-control"
														value={setting.colorOrange}
														onChange={this.handleChange}
														onBlur={this.handleOnBlur}
													/>
												</div>
											</div>
										</div>

										<div className="form-group row">
											<label className="col-lg-3 control-label text-lg-right pt-2">Background Color</label>
											<div className="col-lg-6">
												<div className="input-group color colorClear" data-plugin-colorpicker onClick={this.handColorClick}>
													<span className="input-group-text input-group-addon"><i></i></span>
													<input type="text" name="colorClear" className="form-control"
														value={setting.colorClear}
														onChange={this.handleChange}
														onBlur={this.handleOnBlur}
												 	/>
												</div>
											</div>
										</div>
										*/ }
									</form>
								</div>

								<footer className="card-footer">
										<div className="row justify-content-end">
											<div className="col-sm-9">
												<button type="submit" className="btn btn-primary" onClick={this.handleSave}>Confirm</button>
												<button type="reset" className="btn btn-default" onClick={this.clearForm}>Reset</button>
											</div>
										</div>
									</footer>
							</section>
						</div>
					</div>
			</section>
    	)
	}
}

export default compose(
	graphql(GraphqlTag.QueryGetSetting, {
		options: (props) => ({
			fetchPolicy: 'network-only',
			variables: { id: localStorage.getItem('subHandsApps') },
		}),
		props: ({ data: { getSetting, loading } }) => ({
			settingData: getSetting,
			loading
		})
 	}),
	graphql(GraphqlTag.MutationCreateSetting, {
		props: (props) => ({
			createSetting: (setting) => {
				return props.mutate({
					variables: convertEmptyString(setting),
					optimisticResponse: {
						createSetting: {
							...setting, __typename: 'Setting',
						}
					}
				})
			},
		})
 	}),
	graphql(GraphqlTag.MutationUpdateSetting, {
		props: (props) => ({
			updateSetting: (setting) => {
				return props.mutate({
					variables: convertEmptyString(setting),
					optimisticResponse: {
						updateSetting: {
                			...setting, __typename: 'Setting',
						}
					}
				})
			}
		})
	}),
)(Setting);
